import { LogOutIcon, UserIcon } from 'lucide-react'
import { Outlet, useLoaderData, useNavigate } from 'react-router'

import { DashboardLayout } from 'shared/dashboard/Layout'
import { MobileNavMenu } from 'shared/dashboard/MobileNavMenu'
import { ProfileDropdown } from 'shared/dashboard/ProfileDropdown'
import { TextLink, useBreakpoint } from 'slab'

import { Navigation } from './Navigation'

const MOCK_DATA = {
  fullName: 'John Doe',
}

export async function loader () {
  // TODO: Replace this with a real API call, e.g.:
  //
  // ```
  // const data = await queryClient.ensureQueryData(getGetDashboardContextQueryOptions())
  // ```
  const data = await new Promise<typeof MOCK_DATA>((resolve) =>
    setTimeout(() => resolve(MOCK_DATA), 200)
  )

  return {
    data,
  }
}

export function AppLayout () {
  const { data } = useLoaderData<typeof loader>()
  const { breakpointIsAtLeast } = useBreakpoint()
  const navigate = useNavigate()

  const profileDropdown = (
    <ProfileDropdown name={data.fullName}>
      <ProfileDropdown.Item
        leftIcon={UserIcon}
        onSelect={() => navigate('/employers/dashboard/profile')}
      >
        Profile
      </ProfileDropdown.Item>
      <ProfileDropdown.Item
        leftIcon={LogOutIcon}
        onSelect={() => {
          // TODO: Implement logout endpoint
        }}
      >
        Logout
      </ProfileDropdown.Item>
      <ProfileDropdown.Section>
        <div className='px-4 py-2 body-sm text-gray-500 max-w-52'>
          Need help? Contact us at <TextLink href='mailto:support@thatch.com'>support@thatch.com</TextLink>
        </div>
      </ProfileDropdown.Section>
    </ProfileDropdown>
  )

  return (
    <DashboardLayout>
      {breakpointIsAtLeast('md')
        ? (
          <DashboardLayout.Sidebar>
            <div className='animate-in fade-in duration-150'>
              <div className='p-3 border-b border-gray-200'>
                {profileDropdown}
              </div>
              <Navigation />
            </div>
          </DashboardLayout.Sidebar>
          )
        : (
          <DashboardLayout.MobileNavBar>
            <div className='flex h-full justify-between'>
              <MobileNavMenu>
                <Navigation />
              </MobileNavMenu>
              <div className='p-4 flex items-center'>
                {profileDropdown}
              </div>
            </div>
          </DashboardLayout.MobileNavBar>
          )}
      <DashboardLayout.Main>
        <div className='animate-in fade-in duration-150'>
          <Outlet />
        </div>
      </DashboardLayout.Main>
    </DashboardLayout>
  )
}
